import SongCard from "@/components/SongCard";
import { Verified } from "@mui/icons-material";
import { Avatar, Box, Card, CardMedia, Typography } from "@mui/material";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import ActionDrawer from "@/components/ActionDrawer";
import ImageCarousel from "@/components/ImageCarousel";
import NoteActions from "@/components/NoteActions";
import PollContainer from "@/components/PollContainer";
import { SubscribedContext } from "@/providers/Subscribed";
import { renderTextWithMentions } from "@/utils/mentions";
import { formatDate } from "@/utils/time";
import ExperienceCard from "@/components/ExperienceCard";
import LiveCard from "@/components/LiveCard";
import MerchCard from "@/components/MerchCard";

export default function NoteCard({ content }) {
  const navigate = useNavigate();
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const preventLongPressMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const handleClickVideo = (e) => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    return e;
  };

  return (
    <Box id={content.key} style={{ margin: "20px 0", display: "flex" }}>
      {/* <Divider/> */}
      <Avatar
        src={content.owner.meta.profile}
        sx={{ width: 40, height: 40, marginRight: 2, marginTop: 1 }}
        onClick={() => navigate("/" + content.owner.key)}
      />

      <Box id="post-content-container" style={{ flex: 1 }}>
        <Box
          id="post-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            id="user-detail"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="body"
              style={{ marginRight: "5px", fontWeight: "bold" }}
            >
              {/* {post.user.name} */}
              {content.owner.name}
            </Typography>

            <Verified
              color={content.owner.verified ? "secondary" : "disabled"}
              style={{ fontSize: "15px", marginRight: "5px" }}
            />

            <Typography
              variant="caption"
              style={{ marginRight: "5px", color: "darkgray" }}
            >
              {formatDate(content.live)}
            </Typography>
          </Box>

          <ActionDrawer content={content} />
        </Box>

        <Box id="post-content" style={{ marginTop: "-5px" }}>
          {content.meta.text != "" && (
            <Box
              style={{ wordWrap: "break-all", whiteSpace: "pre-wrap" }}
              sx={{ mb: 2 }}
            >
              {/* {} */}
              {!isSubscribed && (
                <Typography
                  variant="contained"
                  color="secondary"
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleModalOpen()}
                >
                  subscribe to @{content.artist_key} to see caption
                </Typography>
              )}
              {isSubscribed && renderTextWithMentions(content.meta.text)}
            </Box>
          )}

          {content.type == "carousel" && (
            <Box sx={{ borderRadius: "20px" }}>
              <ImageCarousel
                content={content}
                height={300}
                borderRadius={"20px"}
              />
            </Box>
          )}

          {content.type == "poll" && <PollContainer content={content} />}

          {content.type == "audio" && <SongCard content={content} />}

          {content.type == "merch" && <MerchCard content={content} />}

          {content.type === "image" && (
            <Box
              // Prevent touch callout on iOS
              style={{
                WebkitTouchCallout: "none",
                WebkitUserSelect: "none",
                KhtmlUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                userSelect: "none",
              }}
              // Add multiple touch/mouse event handlers for better coverage
              onContextMenu={preventLongPressMenu}
              onTouchStart={preventLongPressMenu}
              onTouchEnd={preventLongPressMenu}
              onTouchMove={preventLongPressMenu}
              onMouseDown={preventLongPressMenu}
            >
              <Box style={{ overflow: "hidden", borderRadius: "10px" }}>
                <CardMedia
                  component="img"
                  src={content.meta.url}
                  style={{
                    borderRadius: "10px",
                    pointerEvents: "none", // Additional protection
                    // filter: "blur(15px)", // Add blur effect
                  }}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </Box>
            </Box>
          )}

          {content.type == "video" && (
            <Card style={{ borderRadius: "20px" }}>
              <Box
                style={{
                  overflow: "hidden",
                  borderRadius: "10px",
                  aspectRatio: "1/1",
                }}
                onClick={(e) => handleClickVideo(e)}
              >
                <ReactPlayer
                  url={content.meta.url}
                  // light={content.meta.cover}
                  light={content.meta.cover}
                  // playing
                  controls
                  width="100%"
                  height="100%"
                  // style={{ filter: "blur(15px)" }}
                  onContextMenu={preventLongPressMenu}
                />
              </Box>
            </Card>
          )}

          {content.type == "experience" && <ExperienceCard content={content} />}

          {content.type == "live" && <LiveCard content={content} />}
        </Box>

        <NoteActions content={content} />
      </Box>
    </Box>
  );
}
